import axios from "axios";

const commonHeaders = {
  accept: "application/json",
  "Accept-Language": localStorage.getItem("machinat_lang") || "ar",
};

export const unauthAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: commonHeaders,
  });

const getAccessToken = () => {
  const token = localStorage.getItem("machinat_credentials");

  if (!token) return null;

  try {
    return JSON.parse(token).access_token;
  } catch (error) {
    return null;
  }
};

export const authAxios = () =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      ...commonHeaders,
      authorization: `Bearer ${getAccessToken()}`,
    },
  });
